import { i18n } from '@/utils/i18n';

export const columns = {
    id: {
        show: true,
        title: "№",
        sortable: true,
        column: 'id'
    },
    comment: {
        show: true,
        title: i18n.t('message.comment'),
        sortable: false,
        column: 'comment'
    },
    price: {
        show: true,
        title: i18n.t('message.amount'),
        sortable: false,
        column: 'price'
    },
    type: {
        show: true,
        title: i18n.t('message.type'),
        sortable: false,
        column: 'transaction_type'
    },

    payment_type_id: {
        show: true,
        title: i18n.t('message.payment_type'),
        sortable: false,
        column: 'payment_type_id'
    },

    name: {
        show: true,
        title: i18n.t('message.fio'),
        sortable: false,
        column: 'name'
    },

    part_id: {
        show: true,
        title: i18n.t('message.typebonus'),
        sortable: false,
        column: 'part_id'
    },

    date: {
        show: true,
        title: i18n.t('message.date_0'),
        sortable: false,
        column: 'date'
    },
    created_at: {
        show: true,
        title: i18n.t('message.date'),
        sortable: true,
        column: 'created_at'
    },
    updated_at: {
        show: false,
        title: i18n.t('message.update_date'),
        sortable: true,
        column: 'updated_at'
    },
    settings: {
        show: true,
        title: i18n.t('message.settings'),
        sortable: false,
        column: 'settings'
    }
};
